import { render, staticRenderFns } from "./accordion.vue?vue&type=template&id=f536eebc&scoped=true&"
import script from "./accordion.vue?vue&type=script&lang=ts&"
export * from "./accordion.vue?vue&type=script&lang=ts&"
import style0 from "./accordion.vue?vue&type=style&index=0&id=f536eebc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f536eebc",
  null
  
)

export default component.exports